import Quill from 'quill';
import validator from 'validator';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';

import icons from './icons';

const Module = Quill.import('core/module');
class Toolbar extends Module {
    currentType;
    valid;

    showThemeTooltip = false;
    visibility = false;
    preventClose = false;

    data = {
        href: '',
        path: '',
        rel: 'noopener noreferrer',
        target: '_self'
    };

    labels = {
        external: 'External link',
        email: 'Email',
        phone: 'Phone number',
        openInNewTab: 'Open in new tab',
        posts: 'Posts',
        media: 'Mediathek',
        mediaSelectFile: 'Datei aus Mediathek wählen'
    };

    // options = {}
    types = ['internal', 'posts', 'external', 'email', 'phone', 'media'];
    pages = [];
    posts = [];
    buttons = [];

    range; // TODO: check for selection, if nothing selected, add an input field to panel for the text
    format;
    panel;
    tabs;

    constructor(quill, options) {
        super(quill, options);

        this.quill = quill;
        this.toolbar = quill.getModule('toolbar');
        if (typeof this.toolbar !== 'undefined') {
            this.toolbar.addHandler('link', () => {
                this.handleLink();
            });
        }
    }

    initialize() {
        var btns = document.getElementsByClassName('ql-link');
        if (btns) {
            [].slice.call(btns).forEach(btns => {
                btns.innerHTML = this.options.buttonIcon;
            });
        }

        // !this.pages.length &&
        if (this.options.pages) {
            switch (typeof this.options.pages) {
                case 'object':
                    if (this.options.pages.length) this.pages = this.options.pages;
                    break;

                case 'function':
                    const result = this.options.pages();
                    if (result instanceof Promise) {
                        result.then(pages => {
                            this.pages = pages;
                            // TODO
                            // this.generatePagesList(this.posts);
                        })
                    } else if (result.length) {
                        this.pages = result;
                    }
                    break;
            }
        }

        if (this.options.posts) {
            switch (typeof this.options.posts) {
                case 'object':
                    if (this.options.posts.length) this.posts = this.options.posts;
                    break;

                case 'function':
                    const result = this.options.posts();
                    if (result instanceof Promise) {
                        result.then(posts => {
                            this.posts = posts;
                            // this.generatePostsList(this.posts);
                        })
                    } else if (result.length) {
                        this.posts = result;
                    }
                    break;
            }
        }

        if (this.options.types && this.options.types.length) {
            const validTypes = this.options.types.filter(type => this.types.includes(type));
            if (
                validTypes.length > 1 ||
                (validTypes.length === 1 && validTypes[0] === 'internal' && this.pages.length)
            ) {
                this.types = validTypes;
            }
        }

        if (this.options.submit && this.options.submit.length) {
            this.buttons = this.options.submit;
        }

        if (this.options.content) {
            if (this.options.content.external) this.labels.external = this.options.content.external;
            if (this.options.content.email) this.labels.email = this.options.content.email;
            if (this.options.content.phone) this.labels.phone = this.options.content.phone;
            if (this.options.content.openInNewTab) this.labels.openInNewTab = this.options.content.openInNewTab;
            if (this.options.content.posts) this.labels.posts = this.options.content.posts;
            if (this.options.content.media) this.labels.media = this.options.content.media;
            if (this.options.content.mediaSelectFile) this.labels.mediaSelectFile = this.options.content.mediaSelectFile;
        }
    }

    // setPages(pages) {
    //     this.pages = pages || [];
    // }

    handleLink() {
        this.initialize();

        this.range = this.quill.getSelection() || { index: this.quill.getLength(), length: 0 };
        this.format = this.quill.getFormat(this.range);

        // The page builder only links an existing selection; the plain-text mode (WhatsApp
        // composer) inserts a URL at the caret, so it may open with nothing selected.
        if (!this.options.plainText && !this.range.length) return;

        if (this.format && this.format.link) {
            this.quill.format('link', null, Quill.sources.USER);
        } else {
            this.showLinkPalatte();
        }

        // close palette on text change
        this.quill.on('text-change', (delta, oldDelta, source) => {
            if (source === 'user' && this.visibility && !this.preventClose) {
                this.closeLinkPalette(this.showThemeTooltip);
                // this.quill.getSelection();
            }
        });
    }

    initLinkPanel() {
        this.addLinkElementsToPanel(this.tabs[0].name);
        document.querySelector(`.tab-${this.tabs[0].name}`).classList.add('active');
    }

    showLinkPalatte() {
        this.visibility = true;

        let linkAreaElement = document.createElement('div');

        // let toolbar_container = document.querySelector('.ql-toolbar');
        let range = this.quill.getSelection();
        const atSignBounds = this.quill.getBounds(range.index);

        this.quill.container.appendChild(linkAreaElement);

        linkAreaElement.id = 'link-palette';
        linkAreaElement.style.top = 10 + atSignBounds.top + atSignBounds.height + 'px';

        // Keep a handle to the palette + its caret anchor so the position can be recomputed
        // whenever the panel height changes (e.g. switching to the much shorter media tab).
        this.paletteElement = linkAreaElement;
        this.paletteAnchor = atSignBounds;

        if (this.quill.container.classList.contains('ql-bubble')) {
            const offsetLeft = this.quill.theme.tooltip.root.offsetLeft;
            const offsetWidth = this.quill.theme.tooltip.root.offsetWidth;

            linkAreaElement.style.left = offsetLeft + 'px';
            linkAreaElement.style.minWidth = offsetWidth + 'px';
            linkAreaElement.classList.add('bubble');

            let arrow = document.createElement('span');
            arrow.classList.add('tooltip-arrow');
            arrow.style.left = offsetWidth / 2 + 'px';
            linkAreaElement.appendChild(arrow);

            this.quill.theme.tooltip.hide();
        } else {
            linkAreaElement.style.left = atSignBounds.left + 'px';
            linkAreaElement.classList.add('snow');
        }

        let tabToolbar = document.createElement('div');
        tabToolbar.id = 'tab-toolbar';
        linkAreaElement.appendChild(tabToolbar);

        // panel
        this.panel = document.createElement('div');
        this.panel.id = 'tab-panel';
        linkAreaElement.appendChild(this.panel);

        this.tabs = [];

        this.types.forEach(name => {
            // check if there are internal pages
            // if not, skip the internal tab
            if (name === 'internal' && !this.pages.length) return;

            this.tabs.push({ name, content: icons.link[name] });
        });

        let panelCloseButton = document.createElement('button');
        panelCloseButton.classList.add('close-button');
        panelCloseButton.innerHTML = icons.link.close;
        tabToolbar.appendChild(panelCloseButton);

        panelCloseButton.addEventListener('click', () => {
            this.closeLinkPalette(false);
            this.quill.focus();
        });

        let tabElementHolder = document.createElement('ul');
        tabToolbar.appendChild(tabElementHolder);

        this.tabs.map(tab => {
            // add tab bar
            let tabElement = document.createElement('li');
            tabElement.classList.add('link-tab');
            tabElementHolder.appendChild(tabElement);

            let buttonElement = document.createElement('button');
            buttonElement.type = 'button';
            buttonElement.classList.add('tab-' + tab.name);

            let tabValue = tab.content;
            buttonElement.innerHTML = tabValue;
            buttonElement.dataset.tab = tab.name;
            tabElement.appendChild(buttonElement);

            buttonElement.addEventListener('click', () => {
                this.preventClose = true;

                let activeTab = document.querySelector('#tab-toolbar .link-tab > button.active');
                if (activeTab) activeTab.classList.remove('active');
                buttonElement.classList.toggle('active');
                this.updateLinkContainer(buttonElement);

                setTimeout(() => (this.preventClose = false), 10);
            });
        });

        let buttonToolbar = document.createElement('div');
        buttonToolbar.id = 'button-toolbar';
        linkAreaElement.appendChild(buttonToolbar);

        let buttonTypes = [{ label: 'Add link' }];
        if (this.buttons.filter(btn => !!btn.label).length) buttonTypes = this.buttons;

        let buttonElementHolder = document.createElement('ul');
        buttonToolbar.appendChild(buttonElementHolder);

        // add button bar
        buttonTypes.map(buttonType => {
            if (!buttonType.label) return;

            let listElement = document.createElement('li');
            listElement.classList.add('link-button');
            buttonElementHolder.appendChild(listElement);

            let buttonElement = document.createElement('button');
            buttonElement.classList.add('button-' + buttonType.name);

            let buttonValue = buttonType.label;
            buttonElement.innerHTML = buttonValue;
            if (buttonType.class) buttonElement.dataset.class = buttonType.class;
            listElement.appendChild(buttonElement);

            buttonElement.addEventListener('click', () => {
                switch (this.currentType) {
                    case 'internal':
                        this.data.href = this.data.path;
                        this.data.rel = '';
                        this.data.target = '_self';
                        break;

                    case 'posts':
                        this.data.href = this.data.path;
                        this.data.rel = '';
                        this.data.target = '_self';
                        break;

                    case 'email':
                        this.data.href = 'mailto:' + this.data.href;
                        this.data.rel = 'noopener noreferrer';
                        this.data.target = '_self';
                        break;

                    case 'phone':
                        this.data.href = 'tel:' + this.data.href;
                        this.data.rel = 'noopener noreferrer';
                        this.data.target = '_self';
                        break;

                    case 'media':
                        this.data.rel = '';
                        this.data.target = '_self';
                        break;
                }

                this.showThemeTooltip = true;

                let link = { ...this.data };
                if (buttonElement.dataset.class) link.class = buttonElement.dataset.class;

                if (this.options.plainText) {
                    // WhatsApp has no link markup: insert the resolved URL as plain text
                    // (auto-linked by WhatsApp), replacing the selection if there was one.
                    // Internal/posts paths are storefront-relative, so prepend baseUrl to
                    // produce an absolute, tappable URL.
                    let href = this.data.href || '';
                    if (this.options.baseUrl && href.charAt(0) === '/') {
                        href = String(this.options.baseUrl).replace(/\/$/, '') + href;
                    }
                    const index = this.range ? this.range.index : this.quill.getLength();
                    if (this.range && this.range.length) {
                        this.quill.deleteText(index, this.range.length, Quill.sources.USER);
                    }
                    this.quill.insertText(index, href, Quill.sources.USER);
                    this.quill.setSelection(index + href.length, 0, Quill.sources.USER);
                } else {
                    this.quill.format('link', null, Quill.sources.USER);
                    this.quill.format('link', link, Quill.sources.USER);
                }

                setTimeout(() => (this.showThemeTooltip = false), 0);
            });
        });

        // if (document.getElementById('link-close-div') === null) {
        //     let closeDiv = document.createElement('div');
        //     closeDiv.id = 'link-close-div';
        //     closeDiv.addEventListener('click', () => this.closeLinkPalette(false), false);
        //     document.getElementsByTagName('body')[0].appendChild(closeDiv);
        // } else {
        //     document.getElementById('link-close-div').style.display = 'block';
        // }

        this.initLinkPanel();
        this.repositionPalette();
    }

    // Keep the palette inside the viewport. It defaults to BELOW the caret; when the editor sits
    // near the bottom of the screen that overflows, so flip it above the caret if there's room.
    // Re-run on every panel change (tabs have very different heights — the media tab is short) so
    // a palette flipped-above for the tall internal tab re-anchors to the caret when it shrinks.
    repositionPalette() {
        const element = this.paletteElement;
        const anchor = this.paletteAnchor;
        if (!element || !anchor) return;

        requestAnimationFrame(() => {
            if (!element.parentNode) return;
            // Reset to the default below-caret position, then re-measure from a known baseline.
            element.style.top = 10 + anchor.top + anchor.height + 'px';
            const rect = element.getBoundingClientRect();
            if (rect.bottom > window.innerHeight - 8) {
                const caretViewportTop = rect.top - (10 + anchor.height);
                if (caretViewportTop - rect.height - 10 >= 8) {
                    // Room above the caret in the viewport — flip up.
                    element.style.top = anchor.top - rect.height - 10 + 'px';
                }
            }
            // Whichever way it opened, make sure a scroll container (e.g. the height-capped
            // composer body) reveals the WHOLE palette instead of clipping its top type row.
            // A no-op when the palette is already fully visible.
            element.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
    }

    addHrefFieldToPanel(type, placeholder = '') {
        let inputElementHolder = document.createElement('div');
        inputElementHolder.classList.add('input-row');

        let inputElement = document.createElement('input');
        inputElement.classList.add('input');
        inputElement.classList.add(`href-${type}`);
        inputElement.type = 'textfield';
        inputElement.value = this.data.href;
        inputElement.placeholder = placeholder;
        inputElementHolder.appendChild(inputElement);

        inputElement.addEventListener('input', event => this.updateHref(event.target.value));
        inputElement.addEventListener('change', event => this.updateHref(event.target.value));

        this.panel.appendChild(inputElementHolder);

        return inputElement;
    }

    searchPosts(searchString) {
        document.getElementById('quillPostsLoading').style.display = 'block';

        if (typeof this.options.posts !== 'function') return

        const result = this.options.posts(searchString);
        if (result instanceof Promise) {
            result.then(posts => {
                this.posts = posts;
                this.generatePostsList(this.posts);
            })
        } else if (result.length) {
            this.posts = result;
            this.generatePostsList(this.posts);
        }
    }

    addLinkElementsToPanel(type) {
        this.currentType = type;

        let inputElement, genenrateTree, checkboxElementHolder, labelElement, checkboxElement;
        switch (type) {
            case 'internal':
                // TODO
                // and checkbox for "open in new tab"

                // render tree by dyn. plugin property
                genenrateTree = pages => {
                    let listElementHolder = document.createElement('ul');
                    listElementHolder.classList.add('internal-pages');

                    pages.map(page => {
                        let clickableElement, folder, title, path, children;

                        if (typeof page === 'string') {
                            title = path = page;
                        } else if (typeof page === 'object') {
                            if (page.folder) {
                                folder = page.folder;
                            }
                            if (page.title) {
                                title = page.title;
                            }
                            if (page.path) {
                                path = page.path;
                                if (!title) title = page.path;
                            }
                            if (page.children && page.children.length) {
                                children = page.children;
                            }
                        }

                        if ((title && path) || folder) {
                            let listElement = document.createElement('li');
                            let labelElement = document.createElement('label');

                            if (folder) {
                                labelElement.classList.add('internal-page-folder');
                                labelElement.innerHTML = folder;

                                let folderIconElement = document.createElement('span');
                                folderIconElement.classList.add('folder-icon');
                                folderIconElement.innerHTML = icons.link.folder;

                                let folderElement = document.createElement('div');
                                folderElement.classList.add('folder');
                                folderElement.appendChild(folderIconElement);
                                folderElement.appendChild(labelElement);

                                listElement.appendChild(folderElement);
                            } else {
                                labelElement.classList.add('internal-page-button');
                                labelElement.innerHTML = title;

                                if (page.subTitle) {
                                    let subTitleElement = document.createElement('span');
                                    subTitleElement.classList.add('sub-title');
                                    subTitleElement.innerHTML = page.subTitle;
                                    labelElement.appendChild(subTitleElement);
                                }

                                let checkboxElement = document.createElement('span');
                                checkboxElement.classList.add('checkbox');
                                checkboxElement.innerHTML = icons.link.check;

                                clickableElement = document.createElement('div');
                                clickableElement.classList.add('holder');
                                clickableElement.appendChild(checkboxElement);
                                clickableElement.appendChild(labelElement);
                                clickableElement.dataset.path = path;

                                if (page.disabled) {
                                    clickableElement.classList.add('disabled');
                                }

                                if (this.data.path && this.data.path === path) {
                                    clickableElement.classList.add('active');
                                }

                                listElement.appendChild(clickableElement);
                            }

                            if (children && children.length) {
                                let childrenElementHolder = genenrateTree(children);
                                listElement.appendChild(childrenElementHolder);
                            }

                            listElementHolder.appendChild(listElement);
                        }

                        if (clickableElement) {
                            clickableElement.addEventListener('click', () => {
                                document.querySelectorAll('.internal-pages .holder.active').forEach(el => {
                                    el.classList.remove('active');
                                });

                                if (this.data.path === clickableElement.dataset.path) {
                                    this.updatePath('');
                                } else {
                                    this.updatePath(clickableElement.dataset.path);
                                    clickableElement.classList.add('active');
                                }
                            });
                        }
                    });

                    return listElementHolder;
                };

                let listElementHolder = genenrateTree(this.pages);

                this.panel.appendChild(listElementHolder);
                break;
            case 'posts':

                if (typeof this.options.posts === 'function') {
                    // Searchbar
                    let inputElementHolder = document.createElement('div');
                    inputElementHolder.classList.add('input-row');

                    let inputElement = document.createElement('input');
                    inputElement.classList.add('input');
                    inputElement.type = 'textfield';
                    inputElement.placeholder = 'Beitrag suchen...';
                    inputElementHolder.appendChild(inputElement);

                    inputElement.addEventListener('input', event => this.searchPosts(event.target.value));
                    // inputElement.addEventListener('change', event => this.searchPosts(event.target.value));

                    this.panel.appendChild(inputElementHolder);

                    inputElement.focus();
                }

                //Loading-Spinner
                let loadingSpinner = document.createElement('div');
                loadingSpinner.id = 'quillPostsLoading';
                loadingSpinner.style.display = 'none'
                loadingSpinner.style.width = '40px';
                loadingSpinner.style.height = '40px';
                loadingSpinner.style.border = '6px solid #f3f3f3';
                loadingSpinner.style.borderTop = '6px solid gray';
                loadingSpinner.style.borderRadius = '50%';
                loadingSpinner.style.margin = '10px';
                loadingSpinner.style.animation = 'spin 2s linear infinite';
                this.panel.appendChild(loadingSpinner);

                //No-Results-Div
                let noResultsDiv = document.createElement('div');
                noResultsDiv.id = 'quillPostsNoResults';
                noResultsDiv.innerHTML = 'Keine Beiträge gefunden';
                noResultsDiv.style.display = 'none';
                this.panel.appendChild(noResultsDiv);

                //List-Container
                let ulHolder = document.createElement('ul');
                ulHolder.style.height = '160px';
                ulHolder.style.overflowY = 'scroll';
                ulHolder.id = "quillPostsContainer";
                ulHolder.classList.add('internal-pages');
                this.panel.appendChild(ulHolder);

                // Post-Liste
                if (this.posts && this.posts.length) {
                    this.generatePostsList(this.posts);
                }
                break;
            case 'external':
                // render input field for the link
                // and checkbox for "open in new tab"

                inputElement = this.addHrefFieldToPanel(type, this.labels.external);

                checkboxElementHolder = document.createElement('div');
                checkboxElementHolder.classList.add('input-row');

                labelElement = document.createElement('label');
                labelElement.classList.add('el-checkbox');
                checkboxElementHolder.appendChild(labelElement);

                checkboxElement = document.createElement('input');
                checkboxElement.classList.add('checkbox');
                checkboxElement.classList.add('target');
                checkboxElement.type = 'checkbox';
                checkboxElement.checked = this.data.checked;
                labelElement.appendChild(checkboxElement);

                checkboxElement.addEventListener('change', event => this.updateTarget(event.target.checked));

                let labelSpanElement = document.createElement('span');
                labelSpanElement.innerHTML = this.labels.openInNewTab;
                labelElement.appendChild(labelSpanElement);

                this.panel.appendChild(checkboxElementHolder);

                inputElement.focus();
                break;

            case 'email':
                inputElement = this.addHrefFieldToPanel(type, this.labels.email);
                inputElement.focus();
                break;

            case 'phone':
                inputElement = this.addHrefFieldToPanel(type, this.labels.phone);
                inputElement.focus();
                break;

            case 'media':
                if (this.data.href) {
                    let selectedUrlEl = document.createElement('div');
                    selectedUrlEl.classList.add('media-selected-url');
                    selectedUrlEl.textContent = this.data.href;
                    this.panel.appendChild(selectedUrlEl);
                }

                let mediaButtonHolder = document.createElement('div');
                mediaButtonHolder.classList.add('input-row');

                let mediaButton = document.createElement('button');
                mediaButton.type = 'button';
                mediaButton.classList.add('media-library-button');
                mediaButton.textContent = this.labels.mediaSelectFile;
                mediaButtonHolder.appendChild(mediaButton);
                this.panel.appendChild(mediaButtonHolder);

                mediaButton.addEventListener('click', () => {
                    if (typeof this.options.mediaLibrary === 'function') {
                        this.preventClose = true;
                        this.options.mediaLibrary(url => {
                            this.data.href = url;
                            this.validate();

                            let urlDisplay = this.panel.querySelector('.media-selected-url');
                            if (urlDisplay) {
                                urlDisplay.textContent = url;
                            } else {
                                let urlEl = document.createElement('div');
                                urlEl.classList.add('media-selected-url');
                                urlEl.textContent = url;
                                this.panel.insertBefore(urlEl, mediaButtonHolder);
                            }
                        });
                        setTimeout(() => (this.preventClose = false), 10);
                    }
                });
                break;
        }

        this.validate();
    }

    generatePostsList(posts) {
        let ulHolder = document.getElementById('quillPostsContainer');
        if (ulHolder) ulHolder.innerHTML = "";
        document.getElementById('quillPostsNoResults').style.display = 'none';

        posts.map(post => {
            let clickableElement;

            let listElement = document.createElement('li');
            let labelElement = document.createElement('label');
            labelElement.classList.add('internal-page-button');
            labelElement.innerHTML = post.title;

            if (post.category && post.category.name) {
                let categoryNameElement = document.createElement('span');
                categoryNameElement.classList.add('category-name');
                categoryNameElement.innerHTML = post.category.name;
                labelElement.appendChild(categoryNameElement);
            }

            let checkboxElement = document.createElement('span');
            checkboxElement.classList.add('checkbox');
            checkboxElement.innerHTML = icons.link.check;

            clickableElement = document.createElement('div');
            clickableElement.classList.add('holder');
            clickableElement.appendChild(checkboxElement);
            clickableElement.appendChild(labelElement);
            clickableElement.dataset.path = "/" + post.category.key + "/" + post.key;

            listElement.appendChild(clickableElement);

            ulHolder.appendChild(listElement);

            if (clickableElement) {
                clickableElement.addEventListener('click', () => {
                    document.querySelectorAll('.internal-pages .holder.active').forEach(el => {
                        el.classList.remove('active');
                    });
                    if (this.data.path === clickableElement.dataset.path) {
                        this.updatePath('');
                    } else {
                        this.updatePath(clickableElement.dataset.path);
                        clickableElement.classList.add('active');
                    }
                });
            }

        })

        if (posts.length == 0) {
            document.getElementById('quillPostsNoResults').style.display = 'block';

        }

        document.getElementById('quillPostsLoading').style.display = 'none';
    }

    validate() {
        const value = this.data.href;
        switch (this.currentType) {
            case 'internal':
                this.valid = validator.isURL(this.data.path, {
                    require_protocol: false,
                    require_host: false,
                    require_tld: false
                });
                break;

            case 'posts':
                this.valid = validator.isURL(this.data.path, {
                    require_protocol: false,
                    require_host: false,
                    require_tld: false
                });
                break;

            case 'external':
                this.valid = validator.isURL(value, { require_protocol: true });
                break;

            case 'email':
                this.valid = validator.isEmail(value);
                break;

            case 'phone':
                // let number = parsePhoneNumberFromString(value, 'DE');
                // console.log(number);
                this.valid = validator.isNumeric(value);
                break;

            case 'media':
                this.valid = !!value;
                break;

            default:
        }

        let inputElement = document.querySelector(`.input.href-${this.currentType}`);

        if (inputElement) {
            if (!value || this.valid) {
                inputElement.classList.add('valid');
                inputElement.classList.remove('invalid');
            } else {
                inputElement.classList.add('invalid');
                inputElement.classList.remove('valid');
            }
        }

        if (this.valid) {
            document.querySelectorAll('.link-button > button').forEach(buttonElement => {
                buttonElement.disabled = false;
            });
        } else {
            document.querySelectorAll('.link-button > button').forEach(buttonElement => {
                buttonElement.disabled = true;
            });
        }
    }

    updatePath(value) {
        this.data.path = value;
        this.validate();
    }

    updateHref(value) {
        this.data.href = value;
        this.validate();
    }

    updateRel(value) {
        this.data.rel = value;
    }

    updateTarget(value) {
        this.data.target = value ? '_blank' : '_self';
    }

    updateLinkContainer(tab) {
        while (this.panel.firstChild) {
            this.panel.removeChild(this.panel.firstChild);
        }
        let type = tab.dataset.tab;
        this.addLinkElementsToPanel(type);
        this.repositionPalette();
    }

    closeLinkPalette(showThemeTooltip = true) {
        if (showThemeTooltip && this.quill.container.classList.contains('ql-bubble')) {
            setTimeout(() => this.quill.theme.tooltip.show(), 0);
        }

        this.visibility = false;

        let closeElement = document.getElementById('link-close-div');
        if (closeElement) closeElement.style.display = 'none';

        let linkPaletteElement = document.getElementById('link-palette');
        if (linkPaletteElement) linkPaletteElement.remove();

        this.paletteElement = null;
        this.paletteAnchor = null;

        this.data = {
            href: '',
            path: '',
            rel: 'noopener noreferrer',
            target: '_self'
        };
    }
}

Toolbar.DEFAULTS = {
    buttonIcon: icons.link['']
};

export default Toolbar;
